import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const projectSummaryEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-project-summary", jiraSpaEntry: "async-servicedesk-project-summary" */ './src/ui'
			),
	),
	getPreloadProps: () => ({}),
});
